import React, { useEffect } from "react";
import {
    FaBolt,
    FaShieldAlt,
    FaRocket,
    FaMobileAlt,
    FaSyncAlt,
    FaGoogle
} from "react-icons/fa";
import "./WhyChooseKotlin.css";

const WhyChooseKotlin = () => {

    useEffect(() => {

        const cards = document.querySelectorAll(".wck-card");

        cards.forEach((card, i) => {

            card.style.opacity = "0";

            card.style.transform =
                i % 2 === 0
                    ? "translateY(120px)"
                    : "translateY(-120px)";

            setTimeout(() => {

                card.style.transition = "1s ease";

                card.style.opacity = "1";

                card.style.transform = "translateY(0px)";

            }, i * 180);

        });

    }, []);

    const data = [
        {
            icon: <FaBolt />,
            title: "Fast Development",
            desc: "Kotlin provides concise syntax and modern tools for rapid Android app development.",
        },
        {
            icon: <FaShieldAlt />,
            title: "Highly Secure",
            desc: "Built-in null safety and advanced architecture make Kotlin highly secure.",
        },
        {
            icon: <FaRocket />,
            title: "High Performance",
            desc: "Optimized performance and efficient memory management for Android apps.",
        },
        {
            icon: <FaMobileAlt />,
            title: "Modern Android UI",
            desc: "Create visually engaging Android experiences with modern Kotlin frameworks.",
        },
        {
            icon: <FaSyncAlt />,
            title: "100% Interoperable",
            desc: "Works perfectly with Java and existing Android ecosystems.",
        },
        {
            icon: <FaGoogle />,
            title: "Google Preferred",
            desc: "Officially recommended by Google for Android application development.",
        },
    ];
    return (
        <>
            <section
                style={{
                    position: "relative",
                    background: "#070707",
                    padding: "150px 24px",
                    overflow: "hidden",
                }}
            >

                {/* BACKGROUND */}
                <div className="wck-grid"></div>

                <div className="wck-glow wck-glow1"></div>
                <div className="wck-glow wck-glow2"></div>

                <div
                    style={{
                        maxWidth: "1320px",
                        margin: "0 auto",
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* TOP */}
                    <div className="wck-top">

                        <div className="wck-badge">
                            🚀 Why Kotlin?
                        </div>

                        <h2>
                            Why Choose
                            <br />
                            <span>Kotlin Development</span>
                        </h2>

                        <p>
                            Kotlin helps businesses create secure,
                            scalable and high-performance Android
                            applications with modern architecture and
                            exceptional user experiences.
                        </p>

                    </div>

                    {/* ZIG ZAG LAYOUT */}
                    <div className="wck-wrap">

                        {data.map((item, i) => (

                            <div
                                key={i}
                                className={`wck-card ${i % 2 === 0
                                    ? "left"
                                    : "right"
                                    }`}
                                onMouseEnter={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(-14px) rotate(-1deg)";

                                    e.currentTarget.style.borderColor =
                                        "#E8212A";

                                    e.currentTarget.style.boxShadow =
                                        "0 35px 90px rgba(232,33,42,.18)";

                                }}
                                onMouseLeave={(e) => {

                                    e.currentTarget.style.transform =
                                        "translateY(0px)";

                                    e.currentTarget.style.borderColor =
                                        "rgba(255,255,255,.08)";

                                    e.currentTarget.style.boxShadow =
                                        "none";

                                }}
                            >

                                {/* NUMBER */}
                                <div className="wck-number">
                                    0{i + 1}
                                </div>

                                {/* ICON */}
                                <div className="wck-icon">
                                    {item.icon}
                                </div>

                                {/* CONTENT */}
                                <div className="wck-content">

                                    <h3>{item.title}</h3>

                                    <p>{item.desc}</p>

                                </div>

                                {/* HOVER GLOW */}
                                <div className="wck-hover"></div>

                            </div>

                        ))}

                    </div>

                </div>
            </section>
        </>
    );
};

export default WhyChooseKotlin;